export const gtmConstant = {
    "SecretCode": {
      "PROCESS_NAME": "קוד סודי",
      "STEP_TITLE": {
        "END": "סיום",
        "CARD_SELECTION": "בחירת כרטיס",
        "DISPLAY_CODE": "הצגת הקוד",
        "ERROR":"שגיאה"
      },
      "NA": "NA",
      "FUNNEL_STEP": "funnel_step",
      "FUNNEL_CLICK": "funnel_click"
    }
  };
  
  


// WEBPACK FOOTER //
// ./src/constants/gtmConstant.js